import React, { Component } from "react";
import LoadingImage from "../../../comum/components/LoadingImage";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { observer } from "mobx-react";
import { buscaSemResultado } from "../../../../utils/mensagens";

@observer
export default class TabelaConsultaEdiNf extends Component {
  render() {
    return (
      <div>
        {this.props.loading ? (
          <LoadingImage />
        ) : (
          <React.Fragment>
            <ToolkitProvider
              keyField="Id"
              data={[...this.props.dados]}
              columns={[...this.props.colunas]}
            >
              {props => (
                <BootstrapTable
                  bootstrap4
                  striped
                  bordered={false}
                  noDataIndication={() => buscaSemResultado}
                  classes="tabela tabela-layout"
                  {...props.baseProps}
                />
              )}
            </ToolkitProvider>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/nota-fiscal-transporte/edi/componentes/TabelaConsultaEdiNf.js